module.exports = __webpack_public_path__ + "static/media/logo.fe7ba602.png";


//////////////////
// WEBPACK FOOTER
// ./src/website/img/logo.png
// module id = 439
// module chunks = 0